var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isDesktop || _vm.isMiddleScreen)?_c('div',{class:[
      'g-cursor',
      { 'g-cursor_hover': _vm.hover },
      { 'g-cursor_hide': _vm.hideCursor },
    ]},[_c('div',{staticClass:"g-cursor__circle",style:(_vm.cursorCircle)}),_c('div',{ref:"point",staticClass:"g-cursor__point",style:(_vm.cursorPoint)})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }